<template>
    <div>
        <h5>Edicion de Contenido</h5>
        <hr />
        <div v-on="obtenerInicializarFormulario ?this.inicializarFormulario():this.noHacerNada()" >
                 <div >
                     <h6>Micrositio</h6>
                    <PaginaDeInicio 
                    :prefijo="1"
                    v-on:valorParaElPadre="cambioTipoDePagina" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :parametros="{3: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true}" 
                    :valorDefinido="valorMicrositio" 
                    :idDelInput="'Micrositio'" 
                    :key="keyMicro"></PaginaDeInicio>
                    <br>
                 </div>

                <!-- TIPO MENU -->
                                <div class="form-group">
                                    <h6>Menu</h6>
                                    <C004Menus  
                                        class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioMenu" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formulario.catalogoMenus.ID" 
                                        :parametros="formulario.catalogoMenus.parametros" 
                                        :valorDefinido="formulario.catalogoMenus.valorDefinido" 
                                        :key="keyMenu"></C004Menus>
                                </div>
                                <!-- TIPO DE SUBMENU MENU -->
                                <div class="form-group">
                                    <h6>Submenu</h6>
                                    <C006Submenus  
                                        class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioSubmenu" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formulario.catalogoSubmenu.ID" 
                                        :parametros="formulario.catalogoSubmenu.parametros" 
                                        :valorDefinido="formulario.catalogoSubmenu.valorDefinido" 
                                        :key="keySubmenu"></C006Submenus>
                                </div>
                                <!-- SUBMENUS HIJOS -->
                                <CSelectRecursivo
                                    v-if="formulario.catalogoSubmenu.subMenuSeleccionado != null && formulario.catalogoSubmenu.subMenuSeleccionado.SubmenusQueMePertenecen.length > 0"
                                    v-on:SeleccionoElemento="evtSeleccionSubmenuHijo"
                                    :nodoPrincipal="formulario.catalogoSubmenu.subMenuSeleccionado"
                                    :identificadores="{ nodosHijos: 'SubmenusQueMePertenecen', llave: 'SubmenuId', nombre: 'Titulo' }"
                                    :texoSingularEnSelect="'un tipo de submenu'"
                                    :key="formulario.catalogoSubmenu.hijos.KEY + formulario.catalogoSubmenu.hijos.contRender"></CSelectRecursivo>

 
                <br>
            <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[menuEsDescarga?'active':'' ]" @click="menuEsDescarga=true;menuConSubmenus=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Es Descarga
                        </label>
                        <label class="btn btn-secondary" :class="[!menuEsDescarga?'active':'' ]"  @click="menuEsDescarga=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >No es Descarga
                        </label>

                    
                     <hr/>
                    
            </div>
<br><br>
         
             <div v-if="!menuEsDescarga" class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[menuConSubmenus?'active':'' ]" @click="menuConSubmenus=true">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Con Submenus
                        </label>
                        <label class="btn btn-secondary" :class="[!menuConSubmenus?'active':'' ]"  @click="menuConSubmenus=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Sin Submenus
                        </label>

                    <br> 
                     <hr/>
                     <br><br>
            </div> 
           
            <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons" v-if="menuEsDescarga">
                        <label class="btn btn-secondary" :class="[!visualizarEnVisor?'active':'' ]" @click="visualizarEnVisor=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Descargar Directamente
                        </label>
                        <label class="btn btn-secondary" :class="[visualizarEnVisor?'active':'' ]"  @click="visualizarEnVisor=true">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Visualizar en Visor
                        </label>

                    <br> 
                     <hr/>
            </div>

                    <div >
                        <br>
                      <h6>Ingrese un titulo del Submenu</h6>
                    <input v-model="menuTitulo" type="text" id="texto_vinculo_contenido" :class="'form-control'" placeholder="Ingrese titulo del Menu" />
                   </div><br>


            <div v-if="!menuEsDescarga &&  !menuConSubmenus">
                <h6>Ingrese Ruta del Vinculo o Pagína</h6>
                <input v-model="menuRutaVinculoPagina" class="form-control" type="text" id="titulo_contenido" :class="[!this.campoEsValidoFormulario(titulo) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el título" />
                <hr />
            </div>

        <div v-if="menuEsDescarga">
                <div v-if="vinculoParaArchivo==false" class="btn-group btn-group-toggle elementos-archivos-contenido" data-toggle="buttons">
                    <label :class="[descargaArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="descargaArchivoRadio=true, vinculoArchivoRadio=false">
                        <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo de descarga
                    </label>
                    <label :class="[vinculoArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="vinculoArchivoRadio=true, descargaArchivoRadio=false,limpiarArchivo()">
                        <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo del archivo
                    </label>
                </div><br>
            
                <div >
                     <div class="form-inline" v-if="menuVinculo != null"><h6>Archivo Actual</h6>&nbsp;&nbsp;
              <a class="btn btn-success" :href="descargarArchivo(menuVinculo)"><i class="fas fa-download"></i></a><br>
              &nbsp;&nbsp; 
               <button  class="btn btn-success" v-on:click="AbreElVisor(menuVinculo)"><i class="fas fa-eye"></i></button>
               </div> <br>
                    <h6>Seleccione el archivo de descarga</h6>
                    <input type="file" id="descarga_contenido" ref=""  v-on:change="subirArchivoDescarga($event)" accept=".PDF,.XLSX,.XLSB,.ZIP" />
                </div> <br>
                 <div v-if="vinculoArchivoRadio">
                    <h6>Ingrese el vínculo(URL)</h6>
                    <input v-model="menuVinculo" type="text" id="vinculo_contenido" placeholder="Ingrese el vínculo" />
                </div>

          </div>  
                                            
        </div>

            <div >
                <h6 >Ingrese fecha de publicación</h6>
                <div style="display: flex;">
                    <div style="display: flex; align-items: center;">
                        <h6 v-if="urgenteRadio" style="margin-right: 5px;">Inicio </h6>
                        <datepicker :key="'dtPkInicio'" 
                                    :format="DatePickerFormato"  
                                    :highlighted="highlighted_DtPkInicio"
                                    :disabled-dates="disabledDates_DtPkInicio" 
                                    v-model="fechaDatePickerInicio"
                                    @selected="seleccionDeFechaDtPkInicio"  
                                    :value="this.fechaDefaultDtPkInicio" 
                                    :bootstrap-styling="true"
                                    :calendar-button="true"
                                    calendar-button-icon="far fa-calendar-alt" 
                                    name="fecha" 
                                    :language="languaje"></datepicker>
                    </div>
                    <div v-if="urgenteRadio" style="display: flex; align-items: center;">
                            <h6 style="margin-right: 5px;">Fin </h6>
                            <datepicker :key="'dtPkFin'" 
                                        :format="DatePickerFormato"  
                                        :highlighted="highlighted_DtPkFin"
                                        :disabled-dates="disabledDates_DtPkFin" 
                                        v-model="fechaDatePickerfinal"
                                        @selected="seleccionDeFechaDtPkFin"  
                                        :value="this.fechaDefaultDtPkFinal" 
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="far fa-calendar-alt"  
                                        :class="{'texto-negro': true}" name="fecha" 
                                        :language="languaje"></datepicker>
                    </div>
                </div>
                <hr />
            </div>  
            
            <div>
                <div>                  
                </div>
            </div>
            <div class="text-right">
                <div>
                    <button type="button" class="btn btn-primary" @click="editarMenuMicrositio"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                   <button type="button" class="btn btn-primary" @click="cancelarEdicion"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar</button>

                </div>
                
            </div>    
        </div>
   
</template>
<script>

import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"
import moment from 'moment';
import enumeraciones from '@/../static/js/enumeraciones'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import C006Submenus from '../../Catalogos/C006Submenus.vue'
import Datepicker from 'vuejs-datepicker';
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'
import catalogos from '@/../static/js/catalogos'
import SelectRecursivo from '@/components/SICPO/Micrositios/Menu/SelectRecursivoMicrositio.vue'
import CSelectRecursivo from '@/components/SICPO/Comun/CSelectRecursivo.vue'
import PaginaDeInicio from "@/components/SICPO/Catalogos/C001PaginaInicio.vue"


export default {
     props:{
         menuMicrositio:Object
         
            },
    
    directives: {
        tooltipF
    },
//declaracion de variables 
    data() {
        return {
            keyMicro:1,
            valorMicrositio:-1,
            parametrosSubmenu:{},
            submenuConHijo:false,
            estaEditando:false,
            valorSubmenuDefinido:null,
          submenusMicrositio:[],
          keySubmenu:-1,
          keySelectMenu:1,
          menuEsDescarga:true,
          menuTitulo:null,
          menuRutaVinculoPagina:null,
          menuVinculo:null,
          menuConSubmenus:null,
          tieneOtrosSubmenus:false,
          perteneceASubMenu:false,
          idSubmenuAlQuePetenece:-1,
          historialDeSeleccionSubmenu:[],
          keyMenu:1,
            formulario: {
                esEdicion: false,
                tituloFormulario: 'Formulario alta de submenu',
                mostrarErrores: false,
                mensajeError: null,
                esSubmenuPadre: false,
                catalogoMenus: {
                    ID: 'CMenus-VADSM',
                    REF: 'REFMenus-VADSM',
                    parametros: { MenuId: null, SubmenuId: null, TipoPosicionId: null, PaginaWebId: null, PaginaDeInicioId: 3, ConInactivos: false, ConSubmenus: false, ConTodosLosSubmenus: false, ConTodasLasPaginasWebDelSubmenu: false, ConPaginasWeb: false, ConPaginasDeInicio: false, ConOrdenamientoDelMenu: false, ConOrdenamientoDelSubmenu: false },
                    valorDefinido: -1,
                    menuSeleccionado: null,
                    KEY: 'KMenus-VADSM',
                    contRender: 0
                },
                catalogoSubmenu: {
                    ID: 'CSubMenus-VADSM',
                    REF: 'REFSubMenus-VADSM',
                    parametros: { SubmenuId: null, MenuId: null, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:true, ConTodosLosSubmenusQueMePertenecen: true, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:false, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:false },
                    valorDefinido: -1,
                    subMenuSeleccionado: null,
                    KEY: 'KSubMenus-VADSM',
                    contRender: 0,
                    hijos: {
                        KEY: 'KSubMenuHijo-VADSM',
                        contRender: 0,
                        seleccionado: null,
                        historialDeSeleccion: []
                    }
                },
                titulo: null,
                resaltarTitulo: false,
                esDescarga: false,
                archivo: {
                    EXTENSIONES: '.PDF',
                    esConSubidor: false,
                    objeto: null,
                    IDENTIFICADOR: 'ARCHIVO-SUBMENU'
                },
                url: null,
                mostrarEnVisor: false,
                permiteSubirContenido: false,
                iconos: {
                    ID: 'ID-ListaDeIconos-VADSM',
                    REF: 'REF-ListaDeIconos-VADSM',
                    seleccionado: null,
                    lista: [],
                    KEY: 'KEY-ListaDeIconos-VADSM',
                    contRender: 0
                },
                mostrarOpcionesHerencia: true
            },

            filtrosBusqueda: {
                titulo: null,
                esDescarga: false,
                seMuestraEnVisor: false,
                catalogoPaginasDeInicio: {
                    ID: 'CPaginaInicio',
                    REF: 'REFPaginaInicio',
                    parametros: { PaginaDeInicioId: null, TipoPaginaId: 1, PaginaWebId: null, PaginaMicrositioId: null, MenuId: null, ConInactivas: false, ConMenus: false, ConPaginasWeb: false, ConPaginasMicrositios: false },
                    valorDefinido: -1,
                    paginaSeleccionada: null,
                    KEY: 'KPaginaInicio',
                    contRender: 0
                },
                catalogoMenus: {
                    ID: 'CMenus',
                    REF: 'REFMenus',
                    parametros: { MenuId: null, SubmenuId: null, TipoPosicionId: 1, PaginaWebId: null, PaginaDeInicioId: 3, ConInactivos: false, ConSubmenus: true, ConTodosLosSubmenus: true, ConTodasLasPaginasWebDelSubmenu: false, ConPaginasWeb: false, ConPaginasDeInicio: false, ConOrdenamientoDelMenu: false, ConOrdenamientoDelSubmenu: false },
                    valorDefinido: -1,
                    menuSeleccionado: null,
                    KEY: 'KMenus',
                    contRender: 0
                },
                catalogoSubmenu: {
                    ID: 'CSubMenus',
                    REF: 'REFSubMenus',
                    parametros: { SubmenuId: null, MenuId: null, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:true, ConTodosLosSubmenusQueMePertenecen: true, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:true, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:false },
                    valorDefinido: -1,
                    subMenuSeleccionado: null,
                    KEY: 'KSubMenus',
                    contRender: 0,
                    hijos: {
                        KEY: 'KSubMenuHijo',
                        contRender: 0,
                        seleccionado: null,
                        historialDeSeleccion: []
                    }
                },
                activos: {
                    PAGINA_INICIO: { activo: true, llave: 1 },
                    MENU: { activo: true, lave: 2 }, 
                    TITULO_SUBMENU:{ activo: true, llave: 3 },
                    ACCESO: { activo: true, llave: 4 },
                    HERENCIA_SUBMENU: { activo: true, llave: 5 },
                    POSICION: { activo: true, lave: 2 }, 
                }
            },

            mostrarImagenActual:false,
            idDeContenidoMicrositio:0,
           imagenActual:null,
           archivoActual:null,
           mostrarUltimaColumna:0,
           formatoId:null,
            fechaDatePickerInicio: null,
            fechaDatePickerfinal: new Date(),
            fechaSeleccionada: 0,
            fechaDefaultDtPkInicio: new Date(),
            fechaDefaultDtPkFinal: new Date(),
            DatePickerFormato: 'yyyy-MM-dd',
            languaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
            highlighted_DtPkInicio: {
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(this.informativoRadio) {
                        if(diasDeMes == fechaInicio) {
                            return true
                        }
                    }
                    else if(this.urgenteRadio) {
                        if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                             return true
                        }
                    }
                },
                includeDisabled: false
            },
            highlighted_DtPkFin: { 
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                        return true
                    }
                },
                includeDisabled: false
            },
            disabledDates_DtPkInicio: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaActual = this.obtenerFecha(new Date());
                    if(diasDeMes < fechaActual)
                        return true
                }
            },
            disabledDates_DtPkFin: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes < fechaInicio){
                        return true
                    }
                }
            },
            enumeraciones,
            textoDelContenido: null,
            vinculoParaArchivo:false,
            IMAGEN_CONTENIDO: null,
            ARCHIVO_DESCARGA: null,
            mostrarSubidorDeArchivos: false,
            esImagen:true,
            esTexto:false,
            esComunicado:false,
            visualizarEnVisor:false,
            EsLink:false,
            tituloComunicado:null,
            tituloCarruselYTexto:null,
            textoDelContenidoCarrusel:null,
            tituloContacto:null,
            descripcionContacto:null,
            numeroDeColumnas:[],
            rutaVinculo:null,
            fechaDePublicacion: '',
            fechaDePublicacionFin: '',
            titulo: '',
            tituloCarrusel:null,
            textoVinculo: null,
            textoVinculoArchivo: null,
            textoVinculoPrincipal: null,
            rutaVideo:null,          
            contenidoConListaDeArchivos:false,
            vinculo: null,
            tituloArchivo: null,
            nombrePresidente: null,
            rangoPresidente: null,
            textoMensajeCampoFaltante:'',
            mostrarErroresInput: false,
            existePerdidaDeCambios: false,
            descargaRadio: false,
            vinculoRadio: false,
            textoBotonAgregaraAoV: 'Archivo',
            descargaArchivoRadio: true,
            vinculoArchivoRadio: false,
            vinculoArchivo: null,
            urgenteRadio: false,
            informativoRadio: false,
            sobreescribirArchivo: false,
            listaDeArchivos: [],
            listaDeArchivosBit:new Object(),
            contadorArchivos: 0,
            opcionVaciarListaArchivos: false,
            disposicionEspecial: false,
            esPin: false,
            textoTituloSubmenu: null,
            textoEsComunicado: 'Si esta opción es seleccionada este archivo se mostrará en la página principal del Micrositio con la imagen seleccionada',
            textoVisualizarEnVisor: 'Si esta opción es seleccionada este archivo se podra visualizar antes de poder descargar',
            textoEsImagen:'Si esta opción es seleccionada tendra que agregar una imagen para el carrusel',
            textoEsLink:'Si esta opción es seleccionada podra ingresar un link a una página exterior',
            imagenDeObligacion: null,
            SERVIDOR_LOCAL:'//themisfs/'
        }
    },
    components: {
        C006Submenus,
        Datepicker,
        CSelectGenerico,
        CListaDeImagenes,
        C004Menus: catalogos.SICPO.C004Menus,
        SelectRecursivo,
        CSelectRecursivo,
        PaginaDeInicio
    },
    methods: {
        cambioTipoDePagina:function(evento){
            this.formulario.catalogoMenus.parametros.PaginaDeInicioId = evento.target.value;
            this.keyMenu += 1;
        },
           evtSeleccionSubmenuHijo: function(evento,objetoElemento) {
             // se obtiene submenu padre del submenu hijo seleccionado
            let idSubmenuPadreSTR = evento.target.getAttribute('id');
            let idCompuesto = idSubmenuPadreSTR.split('-');
            let idSubmenuPadre = idCompuesto[idCompuesto.length -1];
            this.submenuConHijo = true;
            this.menuMicrositio.conSubmenuQueMePertenece = true;
        
            this.formulario.catalogoSubmenu.hijos.seleccionado = (this.campoRequeridoEsValido(objetoElemento)) ? objetoElemento : null;
            // se agrega a historial de seleccion para obtener valor valido mas reciente cuando seleccione valores incorrectos (en este caso -1)
            // si es un valor valido lo agrega si no lo elimina del historial
            if(this.campoRequeridoEsValido(this.formulario.catalogoSubmenu.hijos.seleccionado)) {
                this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.push(this.formulario.catalogoSubmenu.hijos.seleccionado);
            }
            else {
                /* this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.pop(); */
                const ELEMENTO_SELECCIONADOS = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.filter(sh => sh.SubmenuAlQuePertenezco.SubmenuId == idSubmenuPadre);
                const ELEMENTO_SELECCIONADO = ELEMENTO_SELECCIONADOS[0];

                if(this.campoRequeridoEsValido(ELEMENTO_SELECCIONADO)) {
                    // elimina los historiales de submenus hijos
                    let indexDeElemento = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.findIndex(sh => sh.SubmenuId == ELEMENTO_SELECCIONADO.SubmenuId);
                    indexDeElemento ++; // metodo slice termina un numero antes del parametro que se le mande como final por eso se suma 1
                    this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion.slice(0,indexDeElemento);

                    // elimina el historial de los submenus con el mismo submenu padre
                    this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = this.formulario.catalogoSubmenu.hijos.historialDeSeleccion
                        .filter(sh => sh.SubmenuAlQuePertenezco.SubmenuId != ELEMENTO_SELECCIONADO.SubmenuAlQuePertenezco.SubmenuId);
                }
            }

        },
            evtCambioMenu: function(evento, menuObjeto) {
            this.formulario.catalogoMenus.valorDefinido = parseInt(evento.target.value);
            this.formulario.catalogoMenus.menuSeleccionado = menuObjeto;

            // se actualiza catalogo de submenus
            this.formulario.catalogoSubmenu.parametros.MenuId = evento.target.value;//this.campoRequeridoEsValido(this.formulario.catalogoMenus.valorDefinido) ?this.formulario.catalogoMenus.valorDefinido : null;
            this.formulario.catalogoSubmenu.valorDefinido = -1;      
            this.formulario.catalogoSubmenu.contRender ++;
            this.formulario.catalogoSubmenu.subMenuSeleccionado = null;
            this.keySubmenu += 1;
           this.menuMicrositio.conSubmenuQueMePertenece = false;
           this.submenuConHijo=false

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.formulario.catalogoSubmenu.hijos.seleccionado = null; 
            this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = [];
            },

           evtCambioSubmenu: function(evento, menuObj) {
               if(parseInt(evento.target.value) == -1){

                   this.formulario.catalogoSubmenu.valorDefinido = parseInt(evento.target.value);
               // console.log("cambio submenu::"+  this.formulario.catalogoSubmenu.valorDefinido)
            this.formulario.catalogoSubmenu.subMenuSeleccionado = menuObj;
             this.menuMicrositio.conSubmenuQueMePertenece = false
             this.submenuConHijo=false

               }else{
                 this.formulario.catalogoSubmenu.valorDefinido = parseInt(evento.target.value);
               //  console.log("cambio submenu::"+  this.formulario.catalogoSubmenu.valorDefinido)
            this.formulario.catalogoSubmenu.subMenuSeleccionado = menuObj;
             this.menuMicrositio.conSubmenuQueMePertenece = true
             this.submenuConHijo=false
               }
            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.formulario.catalogoSubmenu.hijos.seleccionado = null; 
            this.formulario.catalogoSubmenu.hijos.historialDeSeleccion = [];
        },
                campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },

evtCambioSubmenuRecursivo:function(evento,obj){
         this.menuMicrositio.conSubmenuQueMePertenece=true;
         this.menuMicrositio.SubmenuAlQuePertenezco = {SubmenuId:evento.target.value}
          this.historialDeSeleccionSubmenu.push(obj);

},

    validaSubmenus:function(submenus){
            for(var i =0;i<submenus.length;i++){
                if((submenus[i].SubmenusQueMePertenecen.length>0)){
                this.tieneOtrosSubmenus = true;
               this.submenusMicrositio.push(submenus[i]);
                }
    }
    this.submenusMicrositio = submenus;
    this.keySubmenu=2;
    if(this.tieneOtrosSubmenus) this.keySubmenu=1;

        },
AbreElVisor: function(vinculo) {
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
descargarArchivo: function(vinculo) {
  var ejecucion=null;
  if(vinculo != null){
    var rutaArchivo =vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,this.SERVIDOR_LOCAL);
    ejecucion =api.conexion+api.Comun.funcion.DescargarArchivo+'?'+'rutaDelArchivo='+vinculo;
  }
 return ejecucion;
 },

cancelarEdicion:function(){

     this.evtOcultaFormulario(true);
},

evtOcultaFormulario(EsEdicion){

    let opciones={ocultarFormulario:false,esEdicion:EsEdicion,conSubmenuQueMePertenece:this.menuMicrositio.conSubmenuQueMePertenece}
        console.log("ES EDICION::::",opciones)
   if(!EsEdicion){ 
       this.limpiarFormulario()
       this.$emit('OcultarFormulario',opciones); 
       }
   else if (EsEdicion)   this.$emit('OcultarFormulario',opciones);
},

limpiarArchivo:function(){
           
                    this.ARCHIVO_DESCARGA = null;
                    this.vinculo=null;
                    this.mostrarSubidorDeArchivos = false;
                    

},


valoresDeColumnas:function(){
 let numColumnas = this.numeroDeColumnas.length;
                let textoFinal='';

                for(var aux=0; aux< numColumnas;aux++){
                    textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'/');
                }
},
       
         /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * verifica si la fecha de inicio es menor para actualizar el valor de fecha
         * final dinamicamente.
         */
        seleccionDeFechaDtPkInicio: function() {
            this.$nextTick(() => {
              //  let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
              let fechaInicio = this.obtenerFecha(this.contenido.FechaDePublicacion);
              let fechaFinal = this.obtenerFecha(this.fechaDatePickerfinal);
                if(fechaInicio > fechaFinal) {
                    this.fechaDatePickerfinal = this.fechaDatePickerInicio;
                    this.fechaDefaultDtPkFinal = this.fechaDatePickerInicio;
                }
            });
        },
        /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * En caso de no requerirse eliminar metodo
         */
        seleccionDeFechaDtPkFin: function() {
           // de momento no hay logica aqui utilizar despues
        },

        /**
         * Metodo para agregar elemtos tipo archivo al listado que tendra el contenido que se dara de alta,
         * valida si el contenido requiere lista de archivos o solo un archivo.
         */
        agregarArchivosAcontenido: function() {
              if(this.listaDeArchivos.length == 1) {
                 comun.mensajeDeAlerta('Este contenido solo necesita un archivo o viculo a otra pagina ya has agregado uno,<br>Si deseas cambiar el archivo presione el icono de eliminar y repita el proceso para agregar un archivo o vinculo a otra pagina', null, null);
             }
             else {
                this.agregarArchivoEnListado();
             }
          
        },
        /**
         * Metodo encargado de construir objeto tipo archivo y posteriormente agregarlo al listado de archivos.
         */
        agregarArchivoEnListado: function() {
           
             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let camposValidos = true;
             let identificadoresDeArchivo = this.identificardorTipoRutaArchivo();
            
             if(this.campoEsValidoFormulario(identificadoresDeArchivo.rutaDelArchivo)) {
                 let vinculoAotraPaginaEncontrado = this.existeVinculoAotraPagina();
                 if(identificadoresDeArchivo.nombreServidor == 'VinculoPrincipal' && vinculoAotraPaginaEncontrado.existe) {
                     comun.mensajeDeAlerta(`Solo se permite un vinculo a otra pagina y has agregado uno [${vinculoAotraPaginaEncontrado.nombreDelVinculo}], <br>Si deseas cambiar el vinculo a otra pagina presione el icono de eliminar y repita el proceso para agregar un vinculo a otra pagina`, null, null);
                 }  
                 else if( this.listaDeArchivos.length >= 1 && this.existeUnArchivoConEsteNombre(identificadoresDeArchivo.nombreBase,identificadoresDeArchivo.nombreServidor)) {
                     comun.mensajeDeAlerta('No se permiten archivos con el mismo nombre, <br>Cambia el nombre del archivo o elimina el que se encuentra en la lista', null, null);
                 }
                 else {
                     let objetoArchivo = {};            

                     objetoArchivo.NombreBase = identificadoresDeArchivo.nombreBase;             
                     objetoArchivo.NombreEnServidor = identificadoresDeArchivo.nombreServidor;
                     objetoArchivo.RutaDelArchivo = identificadoresDeArchivo.rutaDeArchivo;
                     objetoArchivo.Titulo = (this.campoEsValidoFormulario(this.tituloArchivo))? this.tituloArchivo : 'Sin título';
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.TextoDelVinculo = this.textoVinculoArchivo;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = (this.campoEsValidoFormulario(this.textoVinculoArchivo))? this.textoVinculoArchivo : 'Sin texto de vínculo';                   
                    
                     this.listaDeArchivos.push(objetoArchivo);
                  
                     this.existePerdidaDeCambios = true;
                    
                     this.listaDeArchivosBit[objetoArchivo.RutaDelArchivo] = this.ARCHIVO_DESCARGA;
                     
                     this.contadorArchivos ++;
                   
                     this.limpiarApartadoArchivosFormulario();
                    
                     let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
                     
                   //  if(camposRequeridos.listaDeArchivos.requerido) {
                         comun.mensajeDeAlerta(`El ${this.textoBotonAgregaraAoV} se agregó correctamente`, null, null);
                     //}
                 }
               
             }
             
        },
  

        /**
         * Metodo encargado de verificar si ya existe un vinculo a otra pagina en el listado
         * @returns {boolean} existeVinculoAotraPagina [variable que representa si ya existe el archivo o no]
         */
        existeVinculoAotraPagina: function() {
          
            let vinculoAotraPaginaEncontrado = {
                nombreDelVinculo: null,
                existe: false
            };
            if(this.listaDeArchivos.length > 0) {
                this.listaDeArchivos.filter(a => a.NombreEnServidor == 'VinculoPrincipal').forEach(archivo => {
                    vinculoAotraPaginaEncontrado.existe = true;
                    vinculoAotraPaginaEncontrado.nombreDelVinculo = archivo.NombreBase;
                });
            }
            return vinculoAotraPaginaEncontrado;
        },
         /**
         * Metodo encargado de verificar si ya existe un archivo con el mismo nombre 
         * @param {String} nombreDeArchivo [nombre del archivo a comparar]
         * @param {String} esVinculoOarchivo [indica si el elemento que se agregara al listado es vinculo a otra pagina, vinculo de archivo o archivo]
         * @returns {boolean} existeArchivo [variable que representa si ya existe el archivo o no]
         */
        existeUnArchivoConEsteNombre: function(nombreDeArchivo,esVinculoOarchivo) {
            let existeArchivo = false;
            if(this.listaDeArchivos.length > 0 && esVinculoOarchivo != 'VinculoPrincipal') {
                this.listaDeArchivos.filter(a => a.NombreBase == nombreDeArchivo && a.NombreEnServidor != 'VinculoPrincipal').forEach(archivo => {
                    existeArchivo = true;
                });
            }
            return existeArchivo;
        },
        /**
         * Metodo encargado para clasificar si el usario desea cargar un archivos desde el fromulario o cargarlo desde un vinculo
         * para posteriormente contruir el objeto del archivo. 
         * @see {@link agregarArchivoEnListado}
         * @returns {object} identificadoresDeArchivo [objeto con la estructura de la entidad ArchivosDeContenido]
         */
        identificardorTipoRutaArchivo: function() {
      
            const nombreInicialTipoArchivo = 'Archivo';
            const nombreInicialTipoVinculo = 'Vinculo';
            const nombreInicialTipoVinculoPrincipal = 'VinculoPrincipal';
             let identificadoresDeArchivo = {};
            if(this.vinculoRadio) {
                
                this.textoVinculoPrincipal = this.vinculo;
                
                identificadoresDeArchivo.rutaDelArchivo = this.vinculo;
                identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculoPrincipal;
                identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo a otra pagina,<br>Debes ingresar un vinculo valido a otra pagina';
                identificadoresDeArchivo.nombreBase = this.vinculo;
            }
            else if (this.descargaRadio){
                if(this.vinculoArchivoRadio){
                    identificadoresDeArchivo.rutaDelArchivo = this.vinculo;
                    identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculo + this.contadorArchivos;
                    identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo para el archivo,<br>Debes ingresar un vinculo para poder agregar el archivo';
                    identificadoresDeArchivo.nombreBase = this.vinculo;
                }
                 else {
                     identificadoresDeArchivo.rutaDelArchivo = this.ARCHIVO_DESCARGA;
                     identificadoresDeArchivo.nombreServidor = nombreInicialTipoArchivo + this.contadorArchivos;
                     identificadoresDeArchivo.mensajeError = 'No hay ningún archivo seleccionado,<br>Debes tener un archivo seleccionado para poder agregar el archivo';
                     identificadoresDeArchivo.nombreBase = this.campoEsValidoFormulario(this.ARCHIVO_DESCARGA) ? this.ARCHIVO_DESCARGA.name : null;
                 }
            }
            return identificadoresDeArchivo;
        },
         /**
         * Metodo encargado para limpiar las variables relacionadas con el apartado de archivos dentro del fromulario.  
         */
        limpiarApartadoArchivosFormulario: function() {
                  $("#descarga_contenido").val('');
                  this.ARCHIVO_DESCARGA = null;
                  this.tituloArchivo = null;
                  this.vinculo = null;
                  this.textoVinculoArchivo = null;
             
        },
         /**
         * Metodo encargado de remover items de la lista de archivos.
         * @param {object} evento [evento emitido por el icono de eliminar dentro de la tabla correspondiente al listado de archivos]
         */
        removerArchivoDeLista: function(evento) {
            
            let llaveArchivo = evento.target.getAttribute('id');
            const indexDeElemento = this.listaDeArchivos.findIndex(archivo => archivo.NombreEnServidor == llaveArchivo);
            if(indexDeElemento > -1) {
                this.listaDeArchivos.splice(indexDeElemento, 1);
                delete this.listaDeArchivosBit[llaveArchivo];
                if(this.listaDeArchivos.length < 1){
                    this.existePerdidaDeCambios = false;
                }
            }
        },
         /**
         * Metodo encargado de remover todos los items de la lista de archivo y reiniciar el contador.
         */
        vaciarListaArchivosAgregados: function() {
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
            this.listaDeArchivosBit = new Object();
            this.existePerdidaDeCambios = false;
        },      
        /**
         * Metodo encargado validar si el contenido requiere textoDelVinculo.
         * @returns {boolean} mostrar [variable que representa si se debe mostrar el campo dentro del formulario]
         */
        mostrarTextoDelVinculo: function() {
            let mostrar = true;
             const PAGINA_WEB_CONVOCATORIA = 3;
             const PAGINA_WEB_BOLETIN_ELECTRONICO = 29;
            return mostrar;
        },


        editarMenuMicrositio:function(){
             comun.SeEstaCargandoInformacion(false);
          //   comun.mensajeDeAlerta("Se a Editado Correctamente", null, null);
              const SERVIDOR = api.conexion;
              let llaveArchivo = (this.ARCHIVO_DESCARGA != null) ?'ARCHIVO-MENU':null;
       //   menuVinculo:null,
                     let urlApi = (!this.menuMicrositio.EsNuevo)?SERVIDOR + api.SICPO.sistema.paginaweb.administracionDeSubmenus.ModificarSubmenuPW:
                     SERVIDOR+api.SICPO.sistema.paginaweb.administracionDeSubmenus.AgregarNuevoSubmenuPW;
                     //"SICPO/AdministracionDeSubmenusPW/AgregarNuevoSubmenu";
console.log("URLdeApi::",urlApi)
                     //"SICPO/AdministracionDeSubmenusPW/ModificarSubmenu"
            let peticion = new FormData();
            let menuObjeto = {};
            menuObjeto.RutaParaAccesar = (this.menuEsDescarga ==false)?this.menuRutaVinculoPagina: llaveArchivo;
            menuObjeto.RutaParaAccesar = (menuObjeto.RutaParaAccesar==null)?this.menuMicrositio.RutaParaAccesar:menuObjeto.RutaParaAccesar;
            menuObjeto.SubmenuId =(this.menuMicrositio.EsNuevo==true)?-1:this.menuMicrositio.SubmenuId;
            menuObjeto.SeMuestraEnVisor = this.visualizarEnVisor
            menuObjeto.Titulo =  this.menuTitulo;
            menuObjeto.EsDescarga = this.menuEsDescarga; // representa el valor de esDescarga y menuEspecial
            menuObjeto.Activo = true;
            menuObjeto.OrdenDelMenu= -1;
            menuObjeto.ResaltarElTitulo = false;
            menuObjeto.PermiteSubirContenido = false;
            menuObjeto.Menu=(this.menuMicrositio.conSubmenuQueMePertenece)?null:{MenuId:this.formulario.catalogoMenus.valorDefinido},
            menuObjeto.SubmenuAlQuePertenezco =(this.menuMicrositio.conSubmenuQueMePertenece)?{SubmenuId: this.formulario.catalogoSubmenu.valorDefinido}:null;
            menuObjeto.SubmenuAlQuePertenezco = (this.submenuConHijo)?{SubmenuId:this.formulario.catalogoSubmenu.hijos.seleccionado.SubmenuId}:menuObjeto.SubmenuAlQuePertenezco;
            menuObjeto.Menu = (this.menuMicrositio.EsNuevo && !this.menuMicrositio.conSubmenuQueMePertenece)?{MenuId:this.formulario.catalogoMenus.valorDefinido} :menuObjeto.Menu; 
            if(this.menuConSubmenus) menuObjeto.RutaParaAccesar  = null;
          
            peticion.append("ARCHIVO-MENU",this.ARCHIVO_DESCARGA);
            peticion.append('ReferenciaArchivo', 'ARCHIVO-MENU');
            peticion.append('Submenu', JSON.stringify(menuObjeto));
            peticion.append('ActualizarOrdenDeSubmenu', false);
            peticion.append('RemoverSubmenuHijos', false);
            peticion.append('EsPrueba', false);
                    //   console.log("PETICION APIII ::: ")
                    //   console.log(peticion)
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            comun.SeEstaCargandoInformacion(false);
                    //    console.log("OBJETO A GUARDAR:::",urlApi)
                    //    console.log(menuObjeto)
          
             axios.post(urlApi, peticion, headerPeticion)
                                .then(respuesta => {            
                                    if (respuesta.data.SiHayError) {                                               
                                        let mensajeError = respuesta.data.Error.Mensaje;
                                    } else {
                                      let seEdito = (this.menuMicrositio.EsNuevo)?false:true;
                                        this.evtOcultaFormulario(seEdito);
                                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                    }
                                    comun.SeEstaCargandoInformacion(false);
                                })
                                .catch(excepcion => {
                                    comun.SeEstaCargandoInformacion(false);
                                    console.log(excepcion);
                                } 
                        );   
         

        },
         /**
         * Metodo encargado para clasificar errores arrojados por excepciones y posteriormente informarlo al usuario. 
         * @param {String} error [mensaje de la excepcion capturada]
         */
        informarError: function(error) {
            switch(error){
                case 'Network Error':
                    this.manejoErrorArchivoNoEncontrado();
                    break;
                case 'Ya existe el archivo de descarga seleccionado':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                case 'Ya existe la imagen del comunicado seleccionada':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                default:
                    comun.mensajeDeAlerta(error, null, null);
                    break;
            }
        },
         /**
         * Metodo encargado para manejar el error FileNotFound en navegador. 
         */
        manejoErrorArchivoNoEncontrado: function() {
            const mensajeErrorImagen = 'Recurso no encontrado por favor verifique los campos imagen del contenido y archivo de descarga';
            const mensajeErrorArchivoDescarga = 'Recurso archivo de descarga no encontrado por favor verifique el campo';
            if(this.obtenerCamposRequeridosEnFormulario.RequiereCamposDeComunicado) {
                comun.mensajeDeAlerta(mensajeErrorImagen, null, null);  
            }
            else {
                comun.mensajeDeAlerta(mensajeErrorArchivoDescarga, null, null);
            }
        },   
         /**
         * Metodo encargado para asignar valor de input correspondiente para archivo hacia la variable ARCHIVO_DESCARGA que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente al archivo]
         */
        subirArchivoDescarga: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'DESCARGA')) {
                        this.ARCHIVO_DESCARGA = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                    }
                    else {
                        $("#descarga_contenido").val('');
                        this.ARCHIVO_DESCARGA = null;
                        comun.mensajeDeAlerta('Para los archivos de descarga solo se permiten extensiones PDF,XLSX,XLSB y ZIP,<br>Seleccione otro archivo con una de las siguientes extensiones PDF,XLSX,XLSB o ZIP');
                    }
                }
                else {
                    this.ARCHIVO_DESCARGA = null;
                    this.mostrarSubidorDeArchivos = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        verificaQueSeaElDocumentoCorrecto: function(nombreArchivo,tipoDocumento) {
            const NOMBRE_CORTADO = nombreArchivo.split(".");
            let siEsUnDocumentoValido = false;
            switch(tipoDocumento) {
                case 'DESCARGA':
                    const EXTENSION_ARCHIVO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_ARCHIVO === 'PDF' || EXTENSION_ARCHIVO === 'XLSX' || EXTENSION_ARCHIVO === 'XLSB' || EXTENSION_ARCHIVO === 'ZIP')
                        siEsUnDocumentoValido = true;

                    break;
                case 'IMAGEN':
                    const EXTENSION_IMAGEN = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_IMAGEN === 'JPEG' || EXTENSION_IMAGEN === 'JPG' || EXTENSION_IMAGEN === 'PNG')
                        siEsUnDocumentoValido = true;
                        
                    break;
                default:
            }
            return siEsUnDocumentoValido;
        },
               
         /**
         * Metodo encargado de inicializar el formulario (limpiar los input y variables ralcionadas con logica de alta de contenido). 
         */
        inicializarFormulario: function() {
            this.limpiarFormulario();
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput",false);

        },
        /**
         * Metodo encargado de limpiar cada una de las variables relacionadas con el formulario de alta de contenido. 
         */
        limpiarFormulario: function() {
            this.menuEsDescarga =false;
            this.menuConSubmenus = false;
            this.visualizarEnVisor = false;
            this.menuTitulo=null;
            this.menuRutaVinculoPagina=null;
            this.descargaArchivoRadio = false;
            this.vinculoArchivoRadio=true
             this.ARCHIVO_DESCARGA = null;
             this.filtrosBusqueda.catalogoMenus.valorDefinido=null;
             this.formulario.catalogoMenus.valorDefinido =-1;
            this.formulario.catalogoSubmenu.valorDefinido = -1;
             this.submenusMicrositio=null;
             this.keyMenu +=1;
             this.keySubmenu += 1;

        },

        /**
         * Metodo encargado de obtener la fecha actual con el formato [yyyy-mm-dd]
         */
        obtenerFecha: function(fecha) {
            let fechaActual = fecha;
            let mes = '' + (fechaActual.getMonth() + 1);
            let dia = '' + fechaActual.getDate();
            let year = fechaActual.getFullYear();

            if (mes.length < 2) 
                mes = '0' + mes;
            if (dia.length < 2) 
                dia = '0' + dia;

            return [year, mes, dia].join('-');
        },
        /**
         * Metodo encargado de validar los input correspondientes a fechas
         * fecha de publicación inicial >= fecha actual &&  fecha de publicación inicial < fecha de publicación final
         * fecha de publicación final > fecha de publicación inicial && fecha de publicación final > fecha actual
         */
        validarFechas: function() {
            let fechaValida = false;
            let fechaActual = this.obtenerFecha(new Date());
            let mensajeError = ['La fecha de publicación inicial no puede ser menor a la fecha actual, <br> por favor ingrese una fecha de publicación inicial valida'];
            if(this.fechaDePublicacion >= fechaActual) {
                fechaValida = true;
                mensajeError.pop();
            }
            if(this.urgenteRadio) {
                if(fechaValida && this.fechaDePublicacion < this.fechaDePublicacionFin) {
                    if(this.fechaDePublicacionFin > fechaActual) {
                         fechaValida = true;
                    }
                    else {
                        fechaValida = false;
                        mensajeError.push('La fecha final de publicacion no puede ser menor a la fecha actual, <br> por favor ingrese una fecha final de publicacion valida');
                    }
                }
                else {
                    fechaValida = false;
                    mensajeError.push('La fecha de publicacion inicial no puede ser mayor o igual a la fecha fin de la publicacion, <br> por favor ingrese una fecha de publicacion inicial valida');
                }
            }

            if(!fechaValida){
                comun.mensajeDeAlerta(mensajeError[0]);
            }
            return fechaValida;
        },

        /**
         * Metodo encargado de comparar si un valor esta vacio.  
         * @param {any} input [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValidoFormulario: function(input) {
            let campoValido = true;
            if(input == null || input == undefined || input == "") {
                campoValido = false;
            }
            return campoValido;
        },
        noHacerNada: function() {
            
        },


         ordenarAsc:function(p_array_json, p_key) {
                
                p_array_json.sort(function (a, b) {
                    return a[p_key] > b[p_key];
             });
                },
             ordenarDesc:function(p_array_json, p_key) {
                this.ordenarAsc(p_array_json, p_key); p_array_json.reverse(); 
                },
        /**
         * Metodo encargado de mapear el listado de contenidos obtenido por la API en un nuevo listado con la 
         * estructura requerida() para mostrar el listado en la pestaña modificar orden de contenido.
         * @see ListaOrdenableDeContenido.vue  
         * @param {array} listado [lista de contenidos]
         */
        mapearInformacionParaListado: function(listado) {
            let listaContenidosOriginal = [];
            var urgenteVisibleId = -1;
            let hoy = new Date();
            var j =0;
            for(var i=listado.length;i>0;i--){
            
                let elementoContenido = {
                     id: i, 
                     mostrarDescripcion:false, 
                     hover:false,
                     conIconoUrgenteVisible: false,
                     conIconoMostrarEnInicio: true,
                     contenido: listado[j]
                     
                 }
                 listaContenidosOriginal.push(elementoContenido);
                 j++;
             }
           
            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal",listaContenidosOriginal);
         
        },

         /**
         * Metodo encargado de mostrar alerta bootbox para acerca de sobreescritura de archivos. 
         * @param {string} mensajeR [mensaje que se quiera mostrar en alert]
         */
        informarSobreescrituraDeArchivos: function (mensajeR) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: mensajeR + ",<br> ¿deseas sobreescribir el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.sobreescribirArchivo = true;
                        this.agregarContenidoBD();
                        this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },



        acomodaMenuEnFormulario:function(){
          
          this.menuEsDescarga=this.menuMicrositio.EsDescarga;
         // this.menuRutaParaAccesar=this.menuMicrositio.RutaParaAccesar;
          this.menuTitulo=this.menuMicrositio.Titulo;
          this.menuRutaVinculoPagina = (this.menuMicrositio.EsDescarga)?null:this.menuMicrositio.RutaParaAccesar;
          //this.menuRutaVinculoPagina=this.menuMicrositio.RutaParaAccesar;
          this.menuVinculo=this.menuMicrositio.RutaParaAccesar;
         // this.menuConSubmenus=this.menuMicrositio.ConSubmenus;
          this.visualizarEnVisor = this.menuMicrositio.SeMuestraEnVisor;
          this.filtrosBusqueda.catalogoMenus.valorDefinido =this.menuMicrositio.MenuId
        if(this.menuMicrositio.SubmenuAlQuePertenezco != null){
             this.valorSubmenuDefinido = this.menuMicrositio.SubmenuAlQuePertenezco.SubmenuId;
             this.submenusMicrositio.push(this.menuMicrositio.SubmenuAlQuePertenezco);
             this.formulario.catalogoSubmenu.valorDefinido = this.menuMicrositio.SubmenuAlQuePertenezco.SubmenuId;
        }else{
         //   this.valorSubmenuDefinido = this.menuMicrositio.SubmenuId;
             //this.submenusMicrositio.push(this.menuMicrositio);
            // this.formulario.catalogoSubmenu.valorDefinido = this.menuMicrositio.SubmenuId;
        }
            this.estaEditando=true;
            
            this.valorMicrositio=parseInt(this.menuMicrositio.PaginaDeInicio);
            this. keyMicro += 1;

             this.formulario.catalogoMenus.parametros.PaginaDeInicioId = 3;
            this.formulario.catalogoMenus.valorDefinido = this.menuMicrositio.MenuId;
            this.keyMenu += 1
            //this.formulario.catalogoMenus.valorDefinido = this.menuMicrositio.MenuId;
             this.formulario.catalogoSubmenu.parametros.MenuId = this.menuMicrositio.MenuId;
            
          this.keySubmenu+=1;
          this.keyMenu +=1;
        },
        agregarNuevoMenu:function(){
          this.menuEsDescarga=false;
          this.menuTitulo=null;
          this.menuRutaVinculoPagina = null;
          this.menuVinculo=null;
          this.menuConSubmenus=false;
          this.visualizarEnVisor = false;
          this.submenusMicrositio=null;
          this.keySubmenu+=1;
          //this.menuRutaParaAccesar
        }

    },
   
    mounted() {
            if(this.menuMicrositio.EsNuevo==true)this.agregarNuevoMenu();
            else this.acomodaMenuEnFormulario();
    },
    computed: {

        mostrarErrorEnInput() {
            return this.mostrarErroresInput;
        },
        obtenerCambiarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario;
        },
        obtenerInicializarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput;
        },
        obtenerCamposRequeridosEnFormulario() {
        return this.$store.getters.Get_SICPO_Catalogo_TipoDeFormulario;
            
        },


    }
}
</script>
<style  scoped>
.imagen-actual{
    border-radius:22px;
    border:3px;
    width:80%;
    height:25em;
    margin-left:10%;
    margin-top: 1%; 
    margin-bottom: 1%;
}
.fuente-tabla{
    color:rgb(250, 250, 250);
}

    .container-btn {
        display: flex;                             
        justify-content: space-between; 
    }
    h5, h6{
        user-select: none;
    }
    .btn-group-toggle{
        margin-bottom: 1em;
    }
    .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
        color: white;
        background-color: #57585B;
        border-color: white;
    }
    .btn-secondary {
        color: rgb(106, 108, 112);
        background-color: #323335;
        border-color: rgb(106, 108, 112);
        font-size: 0.95rem;
    }
    .btn-secondary:hover {
        color: white;
        background-color: #323335;
        border-color: white;
    }
    .elementos-archivos-contenido {
         margin-top: 2%;
    }
    .elemento-lista-archivos {
        margin: 0;
    }
    .elemento-eliminar-archivo {
        cursor: pointer;
        margin-left: 4px;
    }
    .linea-vertical {
      width: 0px; /* Use only border style */
      height: 80%;  
      border: 1px inset; /* This is default border style for <hr> tag */
      margin-left: 6px;
    }
    .linea-horizontal {
        margin: 0;
    }
    .opciones-vaciar-listaDeArchivos {
        display: flex; 
        justify-content: flex-start;
    }

    .opcion-ver-listadoArchivos-agregados:hover {
        cursor: pointer;
    }

    .scroll-contenedor {
        height:200px;
        overflow:scroll;
        overflow-x:hidden;
    }

     .contenedor-listado-archivos {
        overflow-y: auto;
        max-height: 200px;
    }

    .contenedor-listado-archivos table {
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
        
    }

    .contenedor-listado-archivos th {
        position: sticky;
        top: 0;
        background: #474749;
        border: 1;
    }
    .contenedor-puntero {
        background: #212529;
        border-radius:2px;
        padding: 10px;
        border:1px solid white;
        margin-bottom: 1.5em;
    }

    .contenedor-cambio-seccion {
       display: flex;
       justify-content: space-between;
    }

    .texto-negro {
        color: black;
    }

    .sin-margen-superior {
        margin-top: 0px;
    }



</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Menu/CFormularioEdicionSubMenusMicrositio.vue